<mat-sidenav-container class="layout" autosize>
  <mat-sidenav
    #drawer
    [mode]="isMobile() ? 'over' : 'side'"
    [disableClose]="!isMobile()"
    class="sidenav"
  >
    <div class="sidebar-shell">
      <button class="brand" type="button" aria-label="Ir al Dashboard" (click)="goHome()">
        <div class="brand-mark">K</div>
        <div>
          <div class="brand-title">Kozaca</div>
          <div class="brand-subtitle">Portal Financiadores</div>
        </div>
      </button>

      <nav class="nav-list">
        <ng-container *ngFor="let item of menu">
          <div class="section-title" *ngIf="hasVisibleChildren(item)">
            {{ item.label }}
          </div>

          <ng-container *ngIf="hasVisibleChildren(item)">
            <ng-container *ngFor="let child of item.children">
              <button
                class="menu-item"
                type="button"
                *ngIf="isVisible(child)"
                [class.active]="isActive(child)"
                (click)="navigate(child)"
              >
                <mat-icon>{{ child.icon }}</mat-icon>
                <span>{{ child.label }}</span>
                <span class="item-badge" *ngIf="child.badge">{{ child.badge }}</span>
              </button>
            </ng-container>
          </ng-container>

          <button
            class="menu-item logout"
            type="button"
            *ngIf="!item.children"
            (click)="navigate(item)"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
          </button>
        </ng-container>
      </nav>


    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <button  class="menu-btn" *ngIf="isMobile()" (click)="toggleSidebar()">
      <mat-icon class="pt-0.5">menu</mat-icon>
    </button>

    <div class="content-shell">
      <app-navbar></app-navbar>
      <main class="content-main">
        <router-outlet></router-outlet>
      </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
